
import { defineComponent, reactive, toRefs, onMounted } from 'vue'
import { ElMessage } from 'element-plus'
/** cheryl.jiang
 * 1. 本页面是数据上传成功后显示的页面，根据链接的type类型显示跳转外链，type=external 可跳转到 https://jobs.kuehne-nagel.com，type=internal 可跳转到https://careerexplorer.kuehne-nagel.com/i/global/en/home 。
 */
export default defineComponent({
  setup() {
    const dataMap = reactive({
      type: '',
      link: ''
    })
    onMounted(() => {
      const search = new URLSearchParams(location.search)
      const schemas = [
        {
          field: 'jobId',
          required: true,
          defaultValue: null
        },
        {
          field: 'jobTitle',
          required: true,
          defaultValue: null
        },
        {
          field: 'type',
          required: true,
          defaultValue: null
        },
        {
          field: 'referrer',
          required: false,
          defaultValue: ''
        }
      ]

      const params = new Map()

      for (const schema of schemas) {
        const { field, required, defaultValue } = schema
        let fieldValue = search.get(field) || defaultValue

        if (required && fieldValue === defaultValue) {
          ElMessage.error({ message: `Link missing necessary parameters [ ${field} ]`, duration: 30 * 1000 })
        }

        if (typeof fieldValue === 'string') {
          fieldValue = decodeURIComponent(fieldValue).trim()
        }
        params.set(field, fieldValue)
      }
      dataMap.type = params.get('type')
      // 跳转链接
      // external->https://jobs.kuehne-nagel.com
      // internal->https://careerexplorer.kuehne-nagel.com/i/global/en/hom
      if (dataMap.type === 'external') {
        dataMap.link = 'https://jobs.kuehne-nagel.com'
      } else {
        dataMap.link = 'https://careerexplorer.kuehne-nagel.com/i/global/en/home'
      }
    })
    return {
      ...toRefs(dataMap)
    }
  }
})
